<div class=" loading" *ngIf="loader">Loading&#8230;</div>
<div class="row no-gutters">
    <div class="col-12">
        <app-preview [userData]="userObj" (routeEdit)="routeForEdit($event)"></app-preview>
    </div>
</div>
<div class="row no-gutters space_between_section_top">
    <div class="col-12 noteContainer d-flex align-items-start">
        <img src="./assets/icons/info-square-filled.svg" alt="" class="pr-2">
        <span id="prequalSingleBorrContent" [innerHTML]="'about.note'|translate"></span>
    </div>
</div>
<div class="row no-gutters top_height_actionButton content_top_mobile_margin">
    <div class="col-12 d-flex d-md-block flex-column-reverse">
        <cancel-button></cancel-button>
        <button type="button" class="common_btn saveNextBtn_features space_between_button"
            (click)="onContinue()">{{'buttonallpages.agreeandcontinue' | translate }}</button>
    </div>
</div>